export class AdyenIdentifyShopperEvent {
    constructor(public paymentStatus: number,
        public paymentResultAction: string,
        public idBooking: number,) {

    }
}